<template>
    <el-container>
        <el-header>
            <div>
                {{$t('default.title')}}
            </div>
            <div>
                <el-button @click.native.prevent="updateUserSetting" type="success" :disabled="buttonDisabledStatus">{{$t('common.save')}}
                </el-button>
            </div>
        </el-header>

        <el-main>
            <div>
                <el-form label-position="left" label-width="140px" :model="userSetting" v-loading="loading" :rules="loginRules" ref="loginForm">

                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-form-item style="width: 67%" :label="$t('default.emailMessage')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.emailMessage"></el-input>
                                </el-form-item>
                                <el-form-item prop="emailCc" :label="$t('default.emailCc')">
                                    <el-input type="text" v-model="userSetting.emailCc"></el-input>
                                </el-form-item>
                                <el-form-item prop="emailBcc" :label="$t('default.emailBcc')">
                                    <el-input type="text" v-model="userSetting.emailBcc"></el-input>
                                </el-form-item>
                                <div>
                                    {{$t('default.emailTip')}}
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>


                    <el-row style="margin-top: 20px;">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <span>{{$t('default.defaultComments')}}</span>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item style="width: 67%" :label="$t('default.invoice')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.invoiceComment"></el-input>
                                </el-form-item>

                                <el-form-item style="width: 67%" :label="$t('default.estimate')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.estimateComment"></el-input>
                                </el-form-item>

                                <el-form-item style="width: 67%" :label="$t('default.purchaseOrder')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.purchaseOrderComment"></el-input>
                                </el-form-item>

                                <el-form-item style="width: 67%" :label="$t('default.creditMemo')">
                                    <el-input type="textarea" :autosize="{minRows: 2}" :placeholder="$t('default.enterDescription')"
                                              v-model="userSetting.creditMemoComment"></el-input>
                                </el-form-item>
                            </el-card>
                        </el-col>
                    </el-row>

                </el-form>

            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {timest, validateEmailCanKong} from '@/utils/validate'
    import {syncCompanySelection} from '@/utils/company'

    export default {
        methods: {
            queryUserSetting() {
                this.loading = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        let selectedData = syncCompanySelection(response.data);
                        if (selectedData == null) {
                            this.loading = false;
                            return;
                        }
                        that.userSetting = selectedData.setting;
                    }
                    this.loading = false;

                    //初始化页面后需要将watch里的监控是否有字段修改改为0,不然每次都会弹是否保存的框
                    this.$watch('userSetting', function () {
                        this.pageHaveChange = 1;
                    }, {deep: true});
                })
            },
            updateUserSetting(flag, next) {
                let self = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.buttonDisabledStatus = true;
                        this.$axios.post('update_setting', {
                            params: {
                                emailMessage: this.userSetting.emailMessage,
                                emailCc: this.userSetting.emailCc,
                                emailBcc: this.userSetting.emailBcc,
                                invoiceComment: this.userSetting.invoiceComment,
                                estimateComment: this.userSetting.estimateComment,
                                purchaseOrderComment: this.userSetting.purchaseOrderComment,
                                creditMemoComment: this.userSetting.creditMemoComment,
                                innerUUID: this.userSetting.innerUUID,
                                accessDate: timest()
                            }
                        }).then(response => {
                            this.loading = false;
                            self.buttonDisabledStatus = false;
                            if (response.data.errorCode === 0) {

                                this.pageHaveChange = 0;

                                let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                                tempUserSetting.emailMessage = this.userSetting.emailMessage;
                                tempUserSetting.emailCc = this.userSetting.emailCc;
                                tempUserSetting.emailBcc = this.userSetting.emailBcc;
                                tempUserSetting.invoiceComment = this.userSetting.invoiceComment;
                                tempUserSetting.estimateComment = this.userSetting.estimateComment;
                                tempUserSetting.purchaseOrderComment = this.userSetting.purchaseOrderComment;
                                tempUserSetting.creditMemoComment = this.userSetting.creditMemoComment;
                                localStorage.setItem('userSetting', JSON.stringify(tempUserSetting));

                                this.$message.success({
                                    message: this.$t('common.updateSuccess'),
                                    center: true
                                });
                                if (flag === 100) {
                                    next();
                                }
                            }
                        }).catch(function () {
                            self.loading = false;
                            self.buttonDisabledStatus = false;
                        })
                    } else {
                        this.$message.error({
                            message: this.$t('default.emailValidError'),
                            center: true
                        });
                    }
                })
            }
        },
        data() {
            const validEmail = (rule, value, callback) => {
                if (!validateEmailCanKong(value)) {
                    callback(new Error(this.$t('common.validEmail')))
                } else {
                    callback()
                }
            };
            return {
                userSetting: {
                    emailCc: ""
                },
                buttonDisabledStatus: false,
                pageHaveChange: 0,
                loading: false,
                loginRules: {
                    emailCc: [{required: false, trigger: 'blur', validator: validEmail}],
                    emailBcc: [{required: false, trigger: 'blur', validator: validEmail}]
                }
            }
        },
        mounted() {
            this.queryUserSetting();
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.pageHaveChange === 1) {
                next(false);
                this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.updateUserSetting(100, next);
                }).catch(function () {
                    next();
                });
            } else {
                next();
            }
        }
    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 700;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .el-input__inner {
        width: 64%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    /deep/ .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        width: 15%;
        text-align: left;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxListform {
        margin-left: 10%;
        margin-top: 20px;
    }

    /deep/ .el-select {
        display: block;
    }

    /deep/ .el-input__suffix {
        left: 0;
    }

    /*去掉textarea右下角样式*/
    /deep/ .el-textarea__inner {
        resize: none;
    }
</style>
<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
